import React from "react";
import "./NotFound.css";

export default () =>
      <div className="NotFound">
        <div className="row">
          <div className="col-md-12">
            <h1>Page not found.</h1>
          </div>
        </div>
      </div>;
  